<template>
  <div>
    <div class="serviceFooter">
      <div class="footer_left">
        <i class="icon-warning"></i>
      </div>
      <div class="footer_right">
        <div class="txt txt-month">
          <span v-if="service === 'malware'">{{ $t('footer.tip1') }}</span>
          <span v-if="service === 'junk'">{{ $t('footer.tip1') }}</span>
          <span v-if="service === 'url'">{{ $t('footer.tip3') }}</span>
          <span v-if="service === 'wifi'">{{ $t('footer.tip8') }}</span>
          <span class="txt-c">© Trustlook .Inc</span>
        </div>
        <div class="txt">
          <span v-if="service === 'malware'">{{ $t('footer.tip2') }}</span>
          <span v-if="service === 'junk'">{{ $t('footer.tip2') }}</span>
          <span v-if="service === 'url'">{{ $t('footer.tip4') }}</span>
          <span v-if="service === 'wifi'">{{ $t('footer.tip9') }}</span>
          <span class="txt-support" @click="jump('/support')">{{ $t('footer.development') }}</span>
        </div>
      </div>
    </div>
    <div class="serviceFooter_min" id="serviceFooter_min">
      <div class="footer_top" @click="show = !show">
        <i class="icon-warning"></i>
        {{ $t('footer.information') }}
        <i :class="show ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </div>
      <div class="footer_center" v-if="show && service === 'malware'">
        <div class="txt txt-month">{{ $t('footer.tip1') }}</div>
        <div class="txt">{{ $t('footer.tip2') }}</div>
      </div>
      <div class="footer_center" v-if="show && service === 'url'">
        <div class="txt txt-month">{{ $t('footer.tip3') }}</div>
        <div class="txt">{{ $t('footer.tip4') }}</div>
      </div>
      <p class="txt-c" :class="show ? '' : 'scale'">© Trustlook .Inc</p>
      <span class="txt-support" @click="jump('/support')">{{ $t('footer.development') }}</span>
    </div>
  </div>
</template>

<script>
import { downAPPBottom } from '../public/validator'
import VueRouter from 'vue-router'

const { isNavigationFailure, NavigationFailureType } = VueRouter

export default {
  name: 'serviceFooter',
  props: {
    service: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      show: false,
      screenWidth: document.documentElement.clientWidth || document.body.clientWidth
    }
  },
  watch: {
    show(newVal, oldVal) {
      this.show = newVal
      this.$emit('scale', newVal)
    }
  },
  methods: {
    jump(url) {
      this.$router.push(url).catch(err => {
        // to hide the below error message
        if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
          throw Error(err)
        }
      })
    },
    handleResize(event) {
      this.screenWidth = document.documentElement.clientWidth
      if (this.screenWidth < 450 && this.show) {
        this.$emit('scale', true)
      } else {
        this.$emit('scale', false)
      }
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted() {
    downAPPBottom('serviceFooter_min', '80px')
  }
}
</script>

<style lang="scss" scoped>
.serviceFooter {
  width: 100%;
  height: 80px;
  @include flex-start-center;
  font-size: 12px;
  border-top: 1px solid rgba(210, 220, 245, 1);
  color: rgba(31, 37, 62, 0.6);
  box-sizing: border-box;
  padding: 0 43px;
  font-family: Lato-Semibold;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 999;
  .footer_left {
    width: 20px;
    margin-right: 12px;
    .icon-warning {
      font-size: 20px;
      color: #74798b;
    }
  }
  .footer_right {
    flex: 1;
    .txt {
      height: 20px;
      text-align: left;
      line-height: 20px;
      position: relative;
    }

    .txt-support,
    .txt-c {
      position: absolute;
      right: 0;
      top: 3px;
      line-height: 20px;
      font-family: NexaBold;
      color: rgba(28, 28, 28, 1);
      font-weight: 600;
    }

    .txt-support {
      text-decoration: underline;
      font-family: Lato-Regular;
      color: rgba(255, 97, 35, 1);
      font-weight: 400;
      cursor: pointer;
    }
  }
}
.serviceFooter_min {
  display: none;
}
@media screen and (max-width: 1085px) {
  .serviceFooter .footer_right .txt > span:first-child {
    display: inline-block;
    width: 60%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
@media screen and (max-width: 450px) {
  .serviceFooter {
    display: none;
  }
  .serviceFooter_min {
    display: block;
    width: 100%;
    box-sizing: border-box;
    border-top: 1px solid rgba(210, 220, 245, 1);
    padding: 24px;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 999;
    .footer_top {
      height: 16px;
      line-height: 16px;
      display: flex;
      align-items: center;
      .icon-warning {
        font-size: 16px;
        margin-right: 5px;
        color: #74798b;
      }
      ::v-deep .el-icon-arrow-down,
      ::v-deep .el-icon-arrow-up {
        color: #ff6123;
        margin-left: 4px;
      }
    }
    .footer_center {
      margin: 12px 0 20px;
      .txt {
        height: 34px;
        margin-left: 21px;
        font-size: 12px;
        font-family: Lato-Regular;
        font-weight: 400;
        color: rgba(98, 102, 119, 1);
        line-height: 15px;
      }
      .txt-month {
        margin-bottom: 6px;
      }
    }
    .txt-c,
    .txt-support {
      display: block;
      width: 100%;
      height: 15px;
      font-size: 12px;
      font-family: NexaBold;
      color: rgba(28, 28, 28, 1);
      line-height: 15px;
      margin-top: 4px;
      text-align: right;
    }
    .txt-support {
      text-decoration: underline;
      font-family: Lato-Regular;
      font-weight: 400;
      color: rgba(255, 97, 35, 1);
    }
    .scale {
      margin-top: -14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/service/footer.vue